// src/components/session/FuriganaToggle.js

import React from 'react';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';
import { useFurigana } from '../../hooks/useFurigana';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const FuriganaToggle = () => {
  const [showFurigana, setFuriganaVisibility] = useFurigana();

  return (
    <Tippy content={showFurigana ? 'Hide Furigana' : 'Show Furigana'} placement="top">
      <button
        onClick={() => setFuriganaVisibility((prev) => !prev)}
        className="p-2 text-content-secondary rounded-full hover:bg-black/10 dark:hover:bg-white/10 transition-colors"
        aria-label="Toggle Furigana"
      >
        {showFurigana ? <EyeSlashIcon className="h-5 w-5" /> : <EyeIcon className="h-5 w-5" />}
      </button>
    </Tippy>
  );
};

export default FuriganaToggle;
